const isServer = process.env.VUE_ENV === 'server';

export default isServer;
